<template>
    <div class="cont_dom">
        <v-header></v-header>
        <div class="mbx" v-if="tableObj != null">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item :to="{ path: '/' }" alt="小查线索">首页</el-breadcrumb-item>
                <el-breadcrumb-item><a href="/wordsList?text=" alt="查推广">查推广</a></el-breadcrumb-item>
                <el-breadcrumb-item><a :href="'/details?id='+detailsId" :alt="tableObj.clueCorpName">{{tableObj.clueCorpName}}</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="cont_title_dom" v-if="tableObj != null">
            <div class="logoDiv">
                <img v-if="tableObj.clueCorpLogo != undefined" class="logo" :src="tableObj.clueCorpLogo" :alt="tableObj.clueCorpName" srcset="">
                <div class="logo_dom" v-else>
                    {{isString(tableObj.clueCorpName)}}
                </div>
            </div>
            <div class="item_dom_content">
                <div class="title_dox">
                    <div v-html="tableObj.clueCorpName"></div>
                    <div class="tag">{{tableObj.clueCorpStatus}}</div>
                </div>
                <div class="tag_box">
                    <div class="tag_box_item">
                        法定代表人：<span>{{tableObj.clueLegalPerson}}</span>
                    </div>
                    <div class="tag_box_item">
                        注册资本：<span>{{tableObj.clueRegCapital==''? '-':tableObj.clueRegCapital}}</span>
                    </div>
                    <div class="tag_box_item">
                        成立时间：<span>{{tableObj.clueFoundDate}}</span>
                    </div>
                </div>
                <div class="tag_box">
                    <div class="tag_box_item">
                        联系地址：<span>{{tableObj.clueCorpAddr}}</span>
                    </div>
                </div>
                <div class="tag_box">
                    <div class="tag_box_item">
                        简介：<span>{{tableObj.clueCorpDesc}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="basics_dom">
            <div class="title_div">企业信息</div>
            <table border="0" class="tableClass" cellspacing="" cellpadding="">
                <tr>
                    <td class="grey">法人/负责人</td>
                    <td class="white">{{tableObj.clueLegalPerson}}</td>
                    <td class="grey">核准日期</td>
                    <td class="white">{{tableObj.clueFoundDate}} 至 无固定期限</td>
                </tr>
                <tr>
                    <td class="grey">注册资本</td>
                    <td class="white">{{tableObj.clueRegCapital==''? '-':tableObj.clueRegCapital}}</td>
                    <td class="grey">营业期限</td>
                    <td class="white">{{tableObj.clueFoundDate}} 至 无固定期限</td>
                </tr>
                <tr>
                    <td class="grey">公司类型</td>
                    <td class="white">有限责任公司</td>
                    <td class="grey">所属行业</td>
                    <td class="white">信息传输、软件和信息技术服务业</td>
                </tr>
                <tr>
                    <td class="grey">注册地址</td>
                    <td class="white" colspan="3">{{tableObj.clueCorpAddr}}</td>
                </tr>
                <tr>
                    <td class="grey">经营范围</td>
                    <td class="white" colspan="3">
                        {{tableObj.clueCorpDesc}}
                    </td>
                </tr>
            </table>
        </div>

        <div class="basics_dom">
            <div class="title_div">推广记录</div>
            <table border="0" v-if="tableObj != null" :class="[isVip() == 1? 'tableClass_twe':'tableClass_twe filterClass']" cellspacing="" cellpadding="">
                <tr class="grey">
                    <td>关键词</td>
                    <td>推广平台</td>
                    <td>推广时间</td>
                </tr>
                <!-- tableObj.keyWordInfos -->
                <tr class="white" v-for="(item,index) in pagingArr" :key="index">
                    <td>
                        <a 
                            :href="item.clueUrlStatus+item.clueKeywordUrl" 
                            :alt="item.clueKeyword"
                            :title="item.clueKeyword">
                            {{item.clueKeyword}}
                        </a>
                    </td>
                    <td><img class="imgClass" :src="logoObj[item.clueSpreadStage]" :alt="item.clueKeyword" :title="item.clueKeyword"></td>
                    <td>{{item.clueSpreadDate}}</td>
                </tr>
            </table>
            <div class="paging_box" v-if="tableObj.keyWordInfos.length > 10">
                <el-pagination
                    layout="prev, pager, next"
                    :total="tableObj.keyWordInfos.length"
                    @current-change="fyFun">
                </el-pagination>
            </div>
            <div class="go_vip_div" v-if="isVip() != 1">
                <div class="vip_div_one">
                    <img src="https://zyprogram.xinchacha.com/xiansuo/vip_icon.png" alt=""/>
                </div>
                <div class="vip_div_twe">
                    <p>开通会员查看更多推广记录</p>
                    <button class="btn" @click="goVip()">立即开通</button>
                </div>
            </div>
        </div>

        <div class="basics_dom">
            <div class="title_div">联系方式</div>
            <table border="0" v-if="telObj != null && telNum != null" :class="[isVip()  == 1? 'tableClass_twe':'tableClass_twe filterClass']" cellspacing="" cellpadding="">
                <tr class="grey">
                    <td>手机号{{telNum.p != 0? telNum.p:''}}</td>
                    <td>固定电话{{telNum.t != 0? telNum.t:''}}</td>
                    <td>邮箱{{telNum.e != 0? telNum.e:''}}</td>
                </tr>
                <tr class="white" v-for="(item,index) in telObj" :key="index">
                    <td>{{isPhone(item)}}</td>
                    <td>{{isTel(item)}}</td>
                    <td>{{isEmail(item)}}</td>
                </tr>
            </table>
            <div class="go_vip_div" v-if="isVip() != 1">
                <div class="vip_div_one">
                    <img src="https://zyprogram.xinchacha.com/xiansuo/vip_icon.png" alt=""/>
                </div>
                <div class="vip_div_twe">
                    <p>开通会员查看更多联系方式</p>
                    <button class="btn" @click="goVip()">立即开通</button>
                </div>
            </div>
        </div>
        
        <v-footer></v-footer>
    </div>
</template>
<script>
var baidu = "https://zyprogram.xinchacha.com/xiansuo/logo/baidu.png";
var sanlou = "https://zyprogram.xinchacha.com/xiansuo/logo/360.png";
var sougou = "https://zyprogram.xinchacha.com/xiansuo/logo/sougou.png";
var shenma = "https://zyprogram.xinchacha.com/xiansuo/logo/shenma.png";
import vHeader from './common/header.vue'
import vFooter from './common/footer.vue'
export default {
    data(){
        return{
            detailsId:'',
            tableObj:null,
            telObj:null,
            telNum:null,
            logoObj:{
				'1':baidu,
				'2':sanlou,
				'3':sougou,
				'4':shenma
			},
            pagingArr:[]
        }
    },
    components:{
        vHeader,
        vFooter
    },
    methods:{
        goVip(){
            return this.$router.push({
                path:'/vipMember'
            });
        },
        fyFun(val){
            this.initListArr(val)
        },
        initListArr(a){
            var listArr = this.tableObj.keyWordInfos;
            var fromNumber = (parseInt(a)-1)*10;
            var to = parseInt(a)*10;
            var pagingArr = []
            for (let index = fromNumber; index < listArr.length; index++) {
                if (index < to) {
                    pagingArr.push(listArr[index]);
                }
            }
            this.pagingArr = [];
            this.pagingArr = pagingArr;
            // console.log(pagingArr);
        },
        isString(a){
			var cc = a.replace(/<\/?.+?>/g, "");
			return cc.substring(0,4);
		},
        infoFn(){
            var _this = this;
            this.getRequest('api/clue/getClueInfo/'+this.detailsId).then(res=>{
                var data = res.data;
                if (data.status == 200) {
                    _this.tableObj = data.obj;
                    if (_this.isVip() == '') {
                        _this.tableObj.keyWordInfos = [
                            {
                                clueKeyword: "样例",
                                clueKeywordIndustry: "3000,300005",
                                clueKeywordUrl: "www.xxx.com",
                                clueSpreadDate: "2022-02-17",
                                clueSpreadStage: 1,
                                clueUrlStatus: "http://"
                            },
                            {
                                clueKeyword: "样例",
                                clueKeywordIndustry: "3000,300005",
                                clueKeywordUrl: "www.xxx.com",
                                clueSpreadDate: "2022-02-17",
                                clueSpreadStage: 2,
                                clueUrlStatus: "http://"
                            },
                            {
                                clueKeyword: "样例",
                                clueKeywordIndustry: "3000,300005",
                                clueKeywordUrl: "www.xxx.com",
                                clueSpreadDate: "2022-02-17",
                                clueSpreadStage: 3,
                                clueUrlStatus: "http://"
                            },
                            {
                                clueKeyword: "样例",
                                clueKeywordIndustry: "3000,300005",
                                clueKeywordUrl: "www.xxx.com",
                                clueSpreadDate: "2022-02-17",
                                clueSpreadStage: 4,
                                clueUrlStatus: "http://"
                            }
                        ]
                    }
                    _this.initListArr(1);
                };
            })

            this.getRequest('api/clue/getMoreWay/'+this.detailsId).then(res=>{
                var data = res.data;
				if(data.status == 200){
					_this.telObj = data.obj;
				}else{
                    _this.telObj = ['13011112222','010-88888888','xxx@xxx.com','13011112222','13011112222']
                }
            })

            this.getRequest('api/clue/getWayCount/'+this.detailsId).then(res=>{
				var data = res.data;
				if(data.status == 200){
					_this.telNum = data.obj;
				}
			})
        },
        isPhone(a){
            var myreg=/^[1][0-9][0-9]{9}$/;
            
            var cc = ""
            if (myreg.test(a) == true) {
                cc = a;
            } else {
                cc = "-";
            }
            return cc
        },
        isEmail(a){
            var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
            var cc = ""
            if (reg.test(a) == true) {
                cc = a;
            } else {
                cc = "-";
            }
            return cc
        },
        isTel(a){
            var aa = false;
            var myreg=/^[1][0-9][0-9]{9}$/;
            var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
            if (myreg.test(a) == false && reg.test(a) == false) {
                aa = a;
            }else{
                aa = "-";
            }
            return aa
        },
        isVip(){
            var isType = localStorage.getItem("clueVip");
            var bb = "";
            if (isType != '' && isType != null) {
                bb = 1
            }
            return bb
        }
    },
    mounted(){
        this.detailsId = this.$route.query.id;
        this.infoFn();
    }
}
</script>
<style lang="scss" scoped>
.filterClass{
    filter:blur(10px);
}
.imgClass{
    width: 40px;
    height: auto;
    vertical-align: middle;
}
.cont_dom{
    width: 100%;
    height: auto;
    background-color: #F8F8F8;
    padding-bottom: 1px;
}

.mbx{
    height: 40px;
    line-height: 40px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    cursor: default;
    @media screen and (max-width: 1400px){
        width: 960px;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
    }
    a{
        cursor: default !important;
    }
}

.cont_title_dom{
    height: auto;
    margin: 0 auto 20px;
    background-color: #fff;
    padding: 30px 45px;
    box-sizing: border-box;
    display: flex;
    @media screen and (max-width: 1400px){
        width: 960px;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
    }
    >div.logoDiv{
        width: 68px;
        height: auto;
        margin-right: 20px;
        >img.logo{
            width: 68px;
            height: auto;
            display: block;
        }
        >div.logo_dom{
            width: 68px;
            height: 68px;
            border-radius: 4px;
            background-image: url('https://zyprogram.xinchacha.com/xiansuo/icon/xinqiye.png');
            background-size: 100px 100px;
            background-position: 100% 100%;
            color: #FFFFFF;
            text-align: center;
            line-height: 26px;
            font-size: 23px;
            padding-top: 8px;
            box-sizing: border-box;
            cursor: default;
        }
    }
    >div.item_dom_content{
        width: calc(100% - 88px);
        height: auto;
        position: relative;
        cursor: default;
        >div.title_dox{
            width: 100%;
            color: #222222;
            font-weight: 400;
            font-size: 22px;
            display: flex;
            margin-bottom: 10px;
            >div.tag{
                width: auto;
                height: 30px;
                line-height: 30px;
                background-color: #E6F1FE;
                padding: 0 9px;
                font-size: 16px;
                color: #0083E6;
                margin-left: 10px;
            }
        }
        >div.tag_box{
            width: 100%;
            height: auto;
            display: flex;
            >div.tag_box_item{
                color: #999999;
                font-size: 16px;
                margin-right: 30px;
                margin-top: 10px;
                >span{
                    color: #666666;
                }
            }
            >div.telBtn{
                color: #588AE1;
                font-size: 18px;
                margin-top: 10px;
            }
        }
    }
}

.basics_dom{
    height: auto;
    margin: 0 auto 20px;
    background-color: #fff;
    padding: 30px 20px;
    box-sizing: border-box;
    position: relative;
    @media screen and (max-width: 1400px){
        width: 960px;
    }
    @media screen and (min-width: 1400px){
        width: 1200px;
    }
    >div.title_div{
        width: 100%;
        height: auto;
        font-size: 20px;
        color: #333333;
        text-align: left;
        cursor: default;
        margin-bottom: 30px;
    }
    >table.tableClass{
        width: 100%;
        height: auto;
        background-color: #E4EEF6;
        cursor: default;
        td.white{
           background-color: #fff; 
           color: #333333;
           font-size: 14px;
           padding: 16px 30px;
           box-sizing: border-box;
        }
        td.grey{
            min-height: 74px;
           background-color: #F5F7FA; 
           color: #333333;
           font-size: 14px;
           width: 148px;
           text-align: center;
        }
    }
    >table.tableClass_twe{
        width: 100%;
        height: auto;
        cursor: default;
        background-color: #E4EEF6;
        tr.grey{
            height: 70px;
            line-height: 70px;
            background-color: #F5F7FA;  
            color: #333333;
            font-size: 16px;
            text-align: center;
        }
        tr.white{
            height: 70px;
            line-height: 70px;
            background-color: #fff; 
            color: #333333;
            font-size: 16px;
            text-align: center;
            a{
                color: #333333;
                text-decoration: none;
            }
        }
    }
    >.paging_box{
        width: 100%;
        height: auto;
        text-align: right;
        margin-top: 20px;
    }
    >.go_vip_div{
        width: 540px;
        height: 186px;
        position: absolute;
        top:30%;
        left: 30%;
        background-color: #FFFFFF;
        box-shadow: 0px 4px 9px 0px rgba(0,0,0,0.2);
        border-radius: 13px;
        display: flex;
        >.vip_div_one{
            width: 36%;
            height: 186px;
            text-align: right;
            padding-top: 5%;
            box-sizing: border-box;
            >img{
                width: auto;
                height: 90%;
            }
        }
        >.vip_div_twe{
            width: 64%;
            height: 186px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            align-items: center;
            align-content: center;
            >p{
                width: 100%;
                color: #333333;
                font-size: 22px;
                text-align: center;
                margin-bottom: 20px;
                cursor: default;
            }
            >.btn{
                width: 112px;
                height: 43px;
                background: #5F91ED;
                border-radius: 4px;
                color: #FFFFFF;
                font-size: 22px;
                border: none;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/qiyeContent.vue